import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Padding } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { ContactInfoCard } from '@/modules/shared/components/contact-info-card/ContactInfoCard'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type DocumentMoreInfoModalProps = InheritableModalProps & {
  onPhoneClick: () => void
}

export const DocumentMoreInfoModal = ({ onPhoneClick, ...props }: DocumentMoreInfoModalProps) => {
  const theme = useTheme()

  const phone = t({
    id: 'signing.azmm-contact.phone.info.office',
    comment: 'Secretariaat nummer',
    message: '+32 9 246 75 75',
  })

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center' gap={theme.UI.Spacing.Space7}>
        <H2 color={theme.Colors.Neutrals.Darkest} noMargin>
          {t({ id: 'signing.more.info.title', message: 'Heb je nog vragen?' })}
        </H2>

        <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'signing.more.info.body1',
            message: 'Neem contact op met het secretariaat voor meer informatie.',
          })}
        </Span>
        <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'signing.more.info.body2',
            message: 'Weet dat je dit document ook in het ziekenhuis kan ondertekenen (op papier) als je dat wenst.',
          })}
        </Span>

        <ContactInfoCard>
          <ContactInfoCard.Name>
            {t({
              id: 'globals.azmm-contact.name',
              comment: 'General contact info name of AZMM',
              message: 'AZ Maria Middelares',
            })}
          </ContactInfoCard.Name>
          <ContactInfoCard.Phone href={`tel:${phone}`} onClick={onPhoneClick}>
            <ContactInfoCard.PhoneNumber>{phone}</ContactInfoCard.PhoneNumber>
            <ContactInfoCard.Icon icon={['fal', 'phone']} />
          </ContactInfoCard.Phone>
        </ContactInfoCard>

        <Padding pb={theme.UI.Spacing.Space2}>
          <Button variant='Primary' onClick={props.onClose}>
            {t({
              id: 'signing.more.info.button.back',
              message: 'Terug naar document',
            })}
          </Button>
        </Padding>
      </FlexColumn>
    </Modal>
  )
}
